import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Delete, Edit, Settings } from "@mui/icons-material";
import "./index.scss";

const SignatureToolbar = ({ 
  onDelete, 
  onEdit, 
  onSettings,
  isApprovalField = false 
}) => {
  return (
    <div className="signature-toolbar">
      {onEdit && (
        <Tooltip title="Change Signature" placement="top">
          <IconButton
            size="small"
            className="toolbar-btn toolbar-btn-edit"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {onSettings && (
        <Tooltip title="Appearance Settings" placement="top">
          <IconButton
            size="small"
            className="toolbar-btn toolbar-btn-settings"
            onClick={(e) => {
              e.stopPropagation();
              onSettings();
            }}
          >
            <Settings fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title="Delete Signature" placement="top">
          <IconButton
            size="small"
            className="toolbar-btn toolbar-btn-delete"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default SignatureToolbar;

